import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { adminLogin } from '@/lib/api';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Please fill in all fields'); return; }
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem('adminToken', res.data.token);
      localStorage.setItem('adminUser', JSON.stringify(res.data.user));
      toast.success('Welcome back, Admin!');
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-[#002FA7] flex items-center justify-center mx-auto mb-4">
            <ShieldCheck className="w-7 h-7 text-white" />
          </div>
          <h1 className="font-heading font-bold text-2xl text-[#09090B]">Admin Access</h1>
          <p className="text-sm text-[#71717A] mt-1">Sign in to manage credit card data</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-xs font-medium text-[#52525B]">Email</Label>
            <Input
              data-testid="admin-login-email"
              type="email"
              placeholder="admin@cardcompare.ae"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="mt-1.5 h-11"
            />
          </div>
          <div>
            <Label className="text-xs font-medium text-[#52525B]">Password</Label>
            <Input
              data-testid="admin-login-password"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="mt-1.5 h-11"
            />
          </div>
          <Button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full h-11 bg-[#002FA7] hover:bg-[#002175] text-white font-medium gap-2"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}
